import { ChangeDetectorRef, Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatSnackBar } from '@angular/material';
import { LearnerService } from 'src/app/services/learner.service';
import { saveAs } from "file-saver";
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
@Component({
  selector: 'app-evidence-reference-l5-management',
  templateUrl: './evidence-reference-l5-management.component.html',
  styleUrls: ['./evidence-reference-l5-management.component.scss']
})
export class EvidenceReferenceL5ManagementComponent implements OnInit {
  // evidenceList = []

  @Input('learner') learnerData;
  @Input('job') singleJob;
  @Input('assessment') evidencerefercnceEdit;
  @Input('list') evidenceList
  evidenceFormEdit: any;
  eviReferenceL5Form: any;
  user: any;
  isLearner: any;
  learnerId: any;
  currentLearner: any;
  jobId: any;
  job
  loading: boolean;
  isDisplay: boolean = false
  private evidenceSubscription: Subject<any> = new Subject<any>();
  private deleteEvidenceSubscription: Subject<any> = new Subject<any>();
  constructor(
    public dialog: MatDialog,
    public _snackBar: MatSnackBar,
    public _learnerService: LearnerService,
    public cd: ChangeDetectorRef
  ) {
    this._learnerService.newEvidenceObservable().subscribe((newEvidence) => {
      console.log("new Evidence Here ====>", newEvidence)
      // let data1 = {
      //   _id: newEvidence.data._id,
      //   title: newEvidence.data.title,
      //   evidenceNo: newEvidence.data.evidenceNo,
      //   feedback: newEvidence.data.feedback

      // }
      let data1 = newEvidence.data
      this.evidenceList.push(data1)
    })

    this._learnerService.removeEvidenceObservable()
      .pipe(
        takeUntil(this.deleteEvidenceSubscription)
      )
      .subscribe((removeEvidence) => {
        console.log("new remove Evidence ====>", removeEvidence)


        let index = this.evidenceList.findIndex(x => x._id === removeEvidence._id);
        if (index > -1) {
          this.evidenceList.splice(index, 1)
          console.log("after learner remove in assignment page", this.evidenceList);
        }
        if (this.evidenceFormEdit) {
          this.isDisplay = true
          this.createForm(this.evidenceFormEdit)
          this.submitEvirefernce()
        }
      })


    this._learnerService.editEvidenceObservable()
      .pipe(
        takeUntil(this.evidenceSubscription)
      )
      .subscribe((editEvidence) => {
        console.log("Here is Edit Evidence Observable===>", editEvidence)
        let data1 = editEvidence[0]
        let index = this.evidenceList.findIndex(x => x._id === editEvidence[0]._id);
        if (index > -1) {
          this.evidenceList.splice(index, 1, data1)
          console.log("after learner remove in assignment page", this.evidenceList);
        }

        if (this.evidenceFormEdit) {
          this.isDisplay = true
          this.createForm(this.evidenceFormEdit)
          this.submitEvirefernce()
        }

      })


  }

  ngOnDestroy() {
    this.evidenceSubscription.next();
    this.evidenceSubscription.complete();
    this.deleteEvidenceSubscription.next();
    this.deleteEvidenceSubscription.complete();
  }

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('userRoles'))
    console.log("userRole Check:", this.user)
    if (this.user && this.user.isLearner) {
      this.isLearner = this.user.isLearner

    }
    // this.createForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log("onchanges in level5", changes);

    if (changes.learnerData && changes.learnerData.currentValue) {
      // this.singleLearner = changes.learnerData.currentValue
      this.learnerId = changes.learnerData.currentValue._id
      this.currentLearner = changes.learnerData.currentValue
    }

    if (changes.singleJob && changes.singleJob.currentValue) {
      this.jobId = changes.singleJob.currentValue[0]._id
      this.job = changes.singleJob.currentValue[0]
      console.log("changes in evidence Reference....JOB", changes.singleJob.currentValue);

    }

    // if (this.learnerId && this.jobId) {
    //   this.getEvidenceList()
    // }

    if (changes.evidencerefercnceEdit && changes.evidencerefercnceEdit.currentValue) {
      console.log("changes.assessmentPlanEdit.currentValue in master", changes.evidencerefercnceEdit.currentValue)
      this.evidenceFormEdit = changes.evidencerefercnceEdit.currentValue
      console.log("assement plan edit data", this.evidenceFormEdit);

      if (this.evidenceFormEdit && this.evidenceFormEdit.eviReferenceL5Form) {
        this.createForm(this.evidenceFormEdit)
      } else {
        this.createForm()
      }

    }

    if (changes.evidenceList && changes.evidenceList.currentValue) {
      this.evidenceList = changes.evidenceList.currentValue
      // console.log("changes in evidence Reference....JOB", this.evidenceList);
    }
    // console.log("Leaner Id", this.learnerId, "jobId", this.jobId)
  }

  // CREATE FORM

  createForm(details?) {
    this.eviReferenceL5Form = new FormGroup({

      eviref1: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref1 : ''),
      eviref2: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref2 : ''),
      eviref3: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref3 : ''),
      eviref4: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref4 : ''),
      eviref5: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref5 : ''),
      eviref6: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref6 : ''),
      eviref7: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref7 : ''),
      eviref8: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref8 : ''),
      eviref9: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref9 : ''),
      eviref10: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref10 : ''),
      eviref11: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref11 : ''),
      eviref12: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref12 : ''),
      eviref13: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref13 : ''),
      eviref14: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref14 : ''),
      eviref15: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref15 : ''),
      eviref16: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref16 : ''),
      eviref17: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref17 : ''),
      eviref18: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref18 : ''),
      eviref19: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref19 : ''),
      eviref20: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref20 : ''),
      eviref21: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref21 : ''),
      eviref22: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref22 : ''),
      eviref23: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref23 : ''),
      eviref24: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref24 : ''),
      eviref25: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref25 : ''),
      eviref26: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref26 : ''),
      eviref27: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref27 : ''),
      eviref28: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref28 : ''),
      eviref29: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref29 : ''),
      eviref30: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref30 : ''),
      eviref31: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref31 : ''),
      eviref32: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref32 : ''),
      eviref33: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref33 : ''),
      eviref34: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref34 : ''),
      eviref35: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref35 : ''),
      eviref36: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref36 : ''),
      eviref37: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref37 : ''),
      eviref38: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref38 : ''),
      eviref39: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref39 : ''),
      eviref40: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref40 : ''),
      eviref41: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref41 : ''),
      eviref42: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref42 : ''),
      eviref43: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref43 : ''),
      eviref44: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref44 : ''),
      eviref45: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref45 : ''),
      eviref46: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref46 : ''),
      eviref47: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref47 : ''),
      eviref48: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref48 : ''),
      eviref49: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref49 : ''),
      eviref50: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref50 : ''),
      eviref51: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref51 : ''),
      eviref52: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref52 : ''),
      eviref53: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref53 : ''),
      eviref54: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref54 : ''),
      eviref55: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref55 : ''),
      eviref56: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref56 : ''),
      eviref57: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref57 : ''),
      eviref58: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref58 : ''),
      eviref59: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref59 : ''),
      eviref60: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref60 : ''),
      eviref61: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref61 : ''),
      eviref62: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref62 : ''),
      eviref63: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref63 : ''),
      eviref64: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref64 : ''),
      eviref65: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref65 : ''),
      eviref66: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref66 : ''),
      eviref67: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref67 : ''),
      eviref68: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref68 : ''),
      eviref69: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref69 : ''),
      eviref70: new FormControl((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref70 : ''),

      feedback1: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref1 : '')),
      feedback2: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref2 : '')),
      feedback3: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref3 : '')),
      feedback4: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref4 : '')),
      feedback5: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref5 : '')),
      feedback6: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref6 : '')),
      feedback7: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref7 : '')),
      feedback8: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref8 : '')),
      feedback9: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref9 : '')),
      feedback10: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref10 : '')),
      feedback11: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref11 : '')),
      feedback12: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref12 : '')),
      feedback13: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref13 : '')),
      feedback14: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref14 : '')),
      feedback15: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref15 : '')),
      feedback16: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref16 : '')),
      feedback17: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref17 : '')),
      feedback18: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref18 : '')),
      feedback19: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref19 : '')),
      feedback20: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref20 : '')),
      feedback21: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref21 : '')),
      feedback22: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref22 : '')),
      feedback23: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref23 : '')),
      feedback24: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref24 : '')),
      feedback25: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref25 : '')),
      feedback26: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref26 : '')),
      feedback27: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref27 : '')),
      feedback28: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref28 : '')),
      feedback29: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref29 : '')),
      feedback30: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref30 : '')),
      feedback31: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref31 : '')),
      feedback32: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref32 : '')),
      feedback33: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref33 : '')),
      feedback34: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref34 : '')),
      feedback35: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref35 : '')),
      feedback36: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref36 : '')),
      feedback37: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref37 : '')),
      feedback38: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref38 : '')),
      feedback39: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref39 : '')),
      feedback40: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref40 : '')),
      feedback41: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref41 : '')),
      feedback42: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref42 : '')),
      feedback43: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref43 : '')),
      feedback44: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref44 : '')),
      feedback45: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref45 : '')),
      feedback46: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref46 : '')),
      feedback47: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref47 : '')),
      feedback48: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref48 : '')),
      feedback49: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref49 : '')),
      feedback50: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref50 : '')),
      feedback51: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref51 : '')),
      feedback52: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref52 : '')),
      feedback53: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref53 : '')),
      feedback54: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref54 : '')),
      feedback55: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref55 : '')),
      feedback56: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref56 : '')),
      feedback57: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref57 : '')),
      feedback58: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref58 : '')),
      feedback59: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref59 : '')),
      feedback60: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref60 : '')),
      feedback61: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref61 : '')),
      feedback62: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref62 : '')),
      feedback63: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref63 : '')),
      feedback64: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref64 : '')),
      feedback65: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref65 : '')),
      feedback66: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref66 : '')),
      feedback67: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref67 : '')),
      feedback68: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref68 : '')),
      feedback69: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref69 : '')),
      feedback70: new FormControl(this.displayFeedback((details && details.eviReferenceL5Form) ? details.eviReferenceL5Form.eviref70 : '')),
    })
  }

  // UTILITY FUNCTIONS

  selectedCriteriaType(event, controlName) {


    console.log("Selected changes..", event.value)

    let tempfeed = []
    let data = event.value
    let tempEvidence = this.evidenceList
    let result = tempEvidence.filter(o1 => data.some(o2 => o1._id === o2));
    let arrayLength = result.length;

    for (let i = 0; i < arrayLength; i++) {

      if (result[i] && result[i].feedback) {
        tempfeed.push(result[i].feedback)

      }
    }

    tempfeed.join()
    this.eviReferenceL5Form.get(controlName).setValue(tempfeed)
    this.evidenceFormEdit.eviReferenceL5Form = this.eviReferenceL5Form.value

  }


  // compareObjects(o1: any, o2: any): boolean {
  //   console.log("compareObjects called")
  //   return o1._id === o2._id;
  // }

  displayFeedback(data?) {
    // console.log("evidence ARRAY==>", data)



    if (data && data.length) {

      let tempEvidence = this.evidenceList
      let result = tempEvidence.filter(o1 => data.some(o2 => o1._id === o2));
      console.log("Hello Here is the feedback==>", result)

      let tempfeed = []
      let arrayLength = result.length;
      for (let i = 0; i < arrayLength; i++) {

        if (result[i] && result[i].feedback) {
          tempfeed.push(result[i].feedback)
        }
      }

      tempfeed.join()
      return tempfeed

    }

  }

  handleSnackBar(data) {
    this.openSnackBar(data.msg, data.button);
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }


  // API CALL

  // getEvidenceList() {
  //   console.log("evidence Refernce Here ...CAll");

  //   this._learnerService.getEvidenceByLearner(this.learnerId, this.jobId).subscribe(res => {
  //     console.log("evidence Refernce Here ...", res);
  //     if (res && res.length) {

  //       // this.evidenceList = res
  //       let tempEvi = []
  //       var arrayLength = res.length;
  //       for (var i = 0; i < arrayLength; i++) {
  //         // console.log(res[i]);
  //         let data = {
  //           _id: (res[i]._id) ? res[i]._id : '',
  //           title: (res[i].title) ? res[i].title : '',
  //           evidenceNo: (res[i].evidenceNo) ? res[i].evidenceNo : '',
  //           feedback: (res[i].feedback) ? res[i].feedback : ''

  //         }
  //         tempEvi.push(data)
  //       }

  //       this.evidenceList = tempEvi
  //       this.createForm(this.evidenceFormEdit)

  //     }
  //   }, (error) => {
  //     console.log("Soeme error occure when Get EVi List", error)
  //   })
  // }


  submitEvirefernce() {

    console.log("this.eviReferenceL5Form.value is here ----> ", this.eviReferenceL5Form.value)
    let data = {
      learnerId: this.learnerId,
      jobId: this.jobId,
      details: {
        eviReferenceL5Form: this.eviReferenceL5Form.value
      }
    }

    console.log("EDit Evidence Object Replace", this.evidenceFormEdit.eviReferenceL5Form)
    this.loading = true
    console.log("eviiiii==>", data)
    this._learnerService.submitPolicy(data).subscribe(res => {
      console.log('Policy res', res);
      this.evidenceFormEdit.eviReferenceL5Form = this.eviReferenceL5Form.value
      if (!this.isDisplay) this.handleSnackBar({ msg: "Data submitted successfully!", button: "Ok" });
      this.loading = false
    }, (err) => {
      this.loading = false
      this.isDisplay = false
      console.log("form not accepted", err)
    })
  }


  downloadEviRef() {
    // let data = this.eviReferenceForm.value
    let data = {
      learner: this.currentLearner,
      jobId: this.jobId,
      formName: 'eviReferenceL5Form'
    }

    this.loading = true
    console.log("data pass for pdf", data);

    this._learnerService.evidenceRefPdf(data).subscribe((res) => {
      this.loading = false
      console.log("HELLO HERE IS RESPONSE:::", res.data)
      let byteArray = new Uint8Array(res.data);
      console.log("======byteArray =======", byteArray)
      let blob = new Blob([byteArray], { type: 'application/pdf' });
      console.log("blobblobblobblobblob", blob)
      let title = this.job.title + '-' + this.currentLearner.name.split(' ').join('_') + ' - Criteria' + '.pdf'
      saveAs(blob, title);
      //  this.isSpinner = false
    }, (error) => {
      console.log("pdf Genarate Some error", error)
      this.loading = false

    })

  }

}
